
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/incentive",
      function () {
        return require("private-next-pages/incentive/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/incentive"])
      });
    }
  